import { AllJobsList, EditWindow, SearchJobFrom } from "../../components";

export default function Alljob() {
  return (
    <>
      <SearchJobFrom />
      <AllJobsList />
      <EditWindow />
    </>
  );
}
